// OWNER: AREA-TEMPLATES
// Section layout: supplies the "Templates" breadcrumb for every page under /templates.
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/templates')({
  staticData: { crumb: 'Templates' },
  component: Outlet,
})
